import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Link, } from 'react-router';
import $ from 'jquery';
import '../../public/css/media/_shipping-estimate.scss';
import { maskLocationName, netcoreScript } from '../utils/utils';
import { getWarehouse } from '../actions/DashboardActions';
import { v4 as uuid } from 'uuid';
import { filterWarehouse } from '../utils/whiteListed';
import OutBoundBanner from './OutBoundBanner';
import ShippingEstimateBreakdown from './ShippingEstimateBreakdown';
// import AlertAdvisory from './AlertAdvisory';

const createReactClass = require('create-react-class');
const metadata = "Calculate how much your US/UK package will cost when you have it delivered to the PH. Click here to use ShippingCart’s free cost estimator tool.";
const ShippingEstimate = createReactClass({

  getInitialState: function () {
    return {
      weight_status: true,
      length_status: true,
      width_status: true,
      height_status: true,
      insured_status: true,
      insured_value_status: true,
      max_weight: 6,
      max_length: 5,
      max_width: 5,
      max_height: 5,
      max_insured: 8,
      length: "",
      width: "",
      height: "",
      insured: "",
      number: "",
      calculated: false,
      insured_value_text: "",
      optionsState: "",
      origin: '3',
      destination: "PH",
      offsize: false,
      selectDefaultValue: "",
      selectDefaultLabel: "None",
      submitted: false,
    }
  },
  componentWillMount() {
    this.props.getWarehouse();
    this.props.clearEstimate();
    $('#SCTitle').text("Get Shipping Estimate | ShippingCart");
  },
  componentDidMount() {
    window.scrollTo(0, 0);
    this.refs.weight.focus();
    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->
  },
  componentWillReceiveProps(nextProps) {
    let insurance_max = null;
    if (this.state.settings) {
      let insurance = null;
      insurance = this.state.settings.filter(data => data.name === "general_setting")
      insurance_max = insurance ? parseFloat(JSON.parse(insurance[0].settings).insurance_max_value.value) : null;
      this.setState({ insurance_max })
    }
    if (nextProps.estimate.fetched) { this.setState({ calculated: true, }); }
    if (nextProps.estimate.fetched) {
      this.setState({
        weight_status: true,
        length_status: true,
        width_status: true,
        height_status: true,
        insured_status: true,
        insured_value_status: true
      });
    }
    if (nextProps.estimate.error !== null) {
      if (nextProps.estimate.error.response && nextProps.estimate.error.response.data.parameters) {
        if (this.state.insured > insurance_max) {
          this.setState({
            insured_status: false, calculated: false, insured_value_status: false,
            insured_value_text: `Insured value cannot be over ${insurance_max}`,
          });
        }
        if (nextProps.estimate.error.response.data.parameters["item.insured_value"]) {
          this.setState({ insured_status: false, calculated: false, });
        }
        if (nextProps.estimate.error.response.data.parameters["item.height"]) {
          this.setState({ height_status: false, calculated: false, });
        }
        if (nextProps.estimate.error.response.data.parameters["item.width"]) {
          this.setState({ width_status: false, calculated: false, });
        }
        if (nextProps.estimate.error.response.data.parameters["item.length"]) {
          this.setState({ length_status: false, calculated: false, });
        }
        if (nextProps.estimate.error.response.data.parameters["item.weight"]) {
          this.setState({ weight_status: false, calculated: false, });
        }
      }
    }
    if (nextProps.settings.destinationSettings !== this.props.settings.destinationSettings) {
      const { data } = nextProps.settings.destinationSettings;
      const settings = data.map(item => item);
      this.setState({ settings });
    }

  },
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.warehouse.warehouse !== this.props.warehouse.warehouse) {
      this.props.getDestinationSettings(this.props.warehouse.warehouse.data[0].id, this.state.destination)
    }
    if (prevState.origin !== this.state.origin) {
      this.props.getDestinationSettings(this.state.origin, this.state.destination)
    }
    if (prevState.destination !== this.state.destination) {
      this.props.getDestinationSettings(this.state.origin, this.state.destination)
    }
  },
  onSubmit(e) {
    e.preventDefault();
    const weight = this.refs.weight.value;
    const length = this.refs.length.value;
    const width = this.refs.width.value;
    const height = this.refs.height.value;
    const insured_value = this.refs.insured_value.value;
    var special_handling = "";

    //this.checkMaxInsuredSetting();

    if (this.refs.special_handling.value === "") {
      special_handling = "0";
    } else {
      special_handling = "1";
    }

    let sc_protect;
    if (this.state.destination !== 'MY') {
      sc_protect = { avail: 1 } 
    }

    this.setState({ weight_status: true, height_status: true, length_status: true, width_status: true, insured_status: true, insured_value_status: true });
    this.props.getEstimate(weight, length, width, height, insured_value, special_handling, this.state.origin, this.state.destination, sc_protect);
  },
  reset(e) {
    e.preventDefault();
    this.refs.weight.value = "";
    this.refs.length.value = "";
    this.refs.height.value = "";
    this.refs.width.value = "";
    this.refs.insured_value.value = "";
    this.refs.special_handling.value = "";
    this.props.clearEstimate();

    window.scrollTo(0, 0);
    this.setState({ calculated: false, });
    this.setState({
      number: "",
      length: "",
      height: "",
      width: "",
      insured: "",
      insured_value_text: "",
      weight_status: true,
      length_status: true,
      width_status: true,
      height_status: true,
      insured_status: true,
      insured_value_status: true,
      offsize: false,
      selectDefaultValue: "",
      selectDefaultLabel: "None"
    });
    this.refs.weight.focus();
  },
  weightValidator(event) {
    var num = event.target.value;

    if (num.length === 0) {
      this.refs.weight.value = "";
    }

    if (num.length === 1) { //1 digit
      this.setState({ max_weight: 6, });

      if (!isNaN(num) && num !== 0) {
        this.setState({ number: num, });
      }
      else {//NOT a number.
        this.refs.weight.value = "";
      }
    }
    else {// 2 or more digits
      if (!isNaN(num)) { //if it is a NUMBER

        if (num < 10) {
          this.setState({ number: num, });
          if (num.length === 4) {
            this.setState({ max_weight: 4, });
          }
        }
        else if (num >= 10 && num < 100) {
          this.setState({ number: num, });
          if (num.length === 5) {
            this.setState({ max_weight: 5, });
          }
        }
        else if (num >= 100 && num < 1000) {
          this.setState({ number: num, });
          if (num.length === 6) {
            this.setState({ max_weight: 6, });
          }
        }
        else if (num >= 1000) {
          this.refs.weight.value = this.state.number;
        }

      }
      else {// NOT a number.
        this.refs.weight.value = this.state.number;
      }
    }
  },
  lengthValidator(event) {
    var num = event.target.value;

    if (num.length === 0) {
      this.refs.length.value = "";
    }

    if (num.length === 1) { //1 digit
      this.setState({ max_length: 5, });

      if (!isNaN(num) && num !== 0) {
        this.setState({ length: num, });
      }
      else {//NOT a number.
        this.refs.length.value = "";
      }
    }
    else {// 2 or more digits
      if (!isNaN(num)) { //if it is a NUMBER

        if (num < 10) {
          this.setState({ length: num, });
          if (num.length === 4) {
            this.setState({ max_length: 4, });
          }
        }
        else if (num >= 10 && num < 100) {
          this.setState({ length: num, });
          if (num.length === 5) {
            this.setState({ max_length: 5, });
          }
        }
        else if (num >= 100) {
          this.refs.length.value = this.state.length;
        }

      }
      else {// NOT a number.
        this.refs.length.value = this.state.length;
      }
    }
  },
  widthValidator(event) {
    var num = event.target.value;

    if (num.length === 0) {
      this.refs.width.value = "";
    }

    if (num.length === 1) { //1 digit
      this.setState({ max_width: 5, });

      if (!isNaN(num) && num !== 0) {
        this.setState({ width: num, });
      }
      else {//NOT a number.
        this.refs.width.value = "";
      }
    }
    else {// 2 or more digits
      if (!isNaN(num)) { //if it is a NUMBER

        if (num < 10) {
          this.setState({ width: num, });
          if (num.length === 4) {
            this.setState({ max_width: 4, });
          }
        }
        else if (num >= 10 && num < 100) {
          this.setState({ width: num, });
          if (num.length === 5) {
            this.setState({ max_width: 5, });
          }
        }
        else if (num >= 100) {
          this.refs.width.value = this.state.width;
        }

      }
      else {// NOT a number.
        this.refs.width.value = this.state.width;
      }
    }
  },
  heightValidator(event) {
    var num = event.target.value;

    if (num.length === 0) {
      this.refs.height.value = "";
    }

    if (num.length === 1) { //1 digit
      this.setState({ max_height: 5, });

      if (!isNaN(num) && num !== 0) {
        this.setState({ height: num, });
      }
      else {//NOT a number.
        this.refs.height.value = "";
      }
    }
    else {// 2 or more digits
      if (!isNaN(num)) { //if it is a NUMBER

        if (num < 10) {
          this.setState({ height: num, });
          if (num.length === 4) {
            this.setState({ max_height: 4, });
          }
        }
        else if (num >= 10 && num < 100) {
          this.setState({ height: num, });
          if (num.length === 5) {
            this.setState({ max_height: 5, });
          }
        }
        else if (num >= 100) {
          this.refs.height.value = this.state.height;
        }

      }
      else {// NOT a number.
        this.refs.height.value = this.state.height;
      }
    }
  },
  InsuredValueValidator(event) {
    var num = event.target.value;

    if (num.length === 0) {
      this.refs.insured_value.value = "";
    }

    if (num.length === 1) { //1 digit
      this.setState({ max_insured: 8, });

      if (!isNaN(num) && num !== 0) {
        this.setState({ insured: num, });
      }
      else {//NOT a number.
        this.refs.insured_value.value = "";
      }
    }
    else {// 2 or more digits
      if (!isNaN(num)) { //if it is a NUMBER

        if (num < 10) {
          this.setState({ insured: num, });
          if (num.length === 4) {
            this.setState({ max_insured: 4, });
          }
        }
        else if (num >= 10 && num < 100) {
          this.setState({ insured: num, });
          if (num.length === 5) {
            this.setState({ max_insured: 5, });
          }
        }
        else if (num >= 100 && num < 1000) {
          this.setState({ insured: num, });
          if (num.length === 6) {
            this.setState({ max_insured: 6, });
          }
        }
        else if (num >= 1000 && num < 10000) {
          this.setState({ insured: num, });
          if (num.length === 7) {
            this.setState({ max_insured: 7, });
          }
        }
        else if (num >= 10000 && num < 100000) {
          this.setState({ insured: num, });
          if (num.length === 8) {
            this.setState({ max_insured: 8, });
          }
        }
        else if (num >= 100000) {
          this.refs.insured_value.value = this.state.insured;
        }

      }
      else {// NOT a number.
        this.refs.insured_value.value = this.state.insured;
      }
    }
  },
  //SC-224 - an error message should be provided when the user typed in Insured value 
  //more than the configured "Maximum value for Insured Value per Item" in admin tools
  /*checkMaxInsuredSetting: function (e) {  
    var insured_value = parseFloat(this.refs.insured_value.value);
    var insurance_max_value = parseFloat(this.props.settings.general_settings.data.settings.insurance_max_value.value);

    if ( insured_value  >  insurance_max_value) {            
      this.setState({ insured_value_status: true});        
      this.setState({insured_value_text: "Declared value entered is more than the configured insured value per item"});      
      this.setState({ insured_status: true});  
      e.preventDefault();
      return false;
    } else {
      this.setState({ insured_value_status: false});      
      this.setState({insured_value_text: ""});
    }
  },  */
  // SC-474 - Off-size items handling
  checkOffsizeItemsHandling: function (offSizeData) {
    this.setState({calculated: false})
    const {weight, dimension} = JSON.parse(offSizeData[0].settings);
    var length = Number(this.refs.length.value);
    var width = Number(this.refs.width.value);
    var height = Number(this.refs.height.value);
    var weightValue = Number(this.refs.weight.value);

    if (length > Number(dimension.value) || width > Number(dimension.value) || height > Number(dimension.value) || weightValue > Number(weight.value)) {
      this.setState({ offsize: true });
      this.setState({ selectDefaultValue: "off-size items" });
      this.setState({ selectDefaultLabel: `Off-size item exceeding ${dimension.value} inches (any side) and/or ${weight.value} lbs`});
    } else {
      this.setState({ offsize: false });
      this.setState({ selectDefaultValue: "" });
      this.setState({ selectDefaultLabel: "None" });
    }
  },
  onChangeLocation(e, type) {
    e.preventDefault();
    const weight = this.refs.weight.value;
    const length = this.refs.length.value;
    const width = this.refs.width.value;
    const height = this.refs.height.value;
    const insured_value = this.refs.insured_value.value;
    let special_handling = "";
    if (this.refs.special_handling.value === "") {
      special_handling = "0";
    } else {
      special_handling = "1";
    }

    let sc_protect;

    this.setState({ weight_status: true, height_status: true, length_status: true, width_status: true, insured_status: true, insured_value_status: true, }, () => {
      if (this.state.destination !== 'MY') {
        sc_protect = { avail: 1 } 
      }
    });

    this.setState({ [type]: e.target.value },
      () => weight && length && width && height && insured_value ?
        this.props.getEstimate(weight, length, width, height, insured_value, special_handling, this.state.origin, this.state.destination, sc_protect) : null);

  },

  injectMediaDonutScript() {

    const axel = Math.random() + "";
    const a = axel * 10000000000000;
    document.write(`<iframe title=${uuid()} src={https://9848754.fls.doubleclick.net/activityi;src=9848754;type=shipp0;cat=shipp0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=${a}? } width="1" height="1" frameBorder="0" style="display:none"></iframe>`);
  },

  render() {
    let per_pound, fixed_fees, outBoundBannerData, offSizeData = null, airFixedFee=10.00, maxWeight=5, maxDimension=23, fixedShippingFee=15, minChargableWeight = null;
    if (this.state.settings) {
      per_pound = this.state.settings.filter(data => data.name === "per_pound_value")
      fixed_fees = this.state.settings.filter(data => data.name === "fixed_fees")[0]
      outBoundBannerData = this.state.settings.filter(data => data.name === "outbound_banner")
      offSizeData = this.state.settings.filter(data => data.name === "offsize")
      minChargableWeight = this.state.settings.filter(data => data.name === "minimum_chargeable_weight")[0]
    }

    if (fixed_fees) {
      fixed_fees = fixed_fees.settings && JSON.parse(fixed_fees.settings);
      airFixedFee = fixed_fees.air_fixed_fee.value || airFixedFee;
      maxWeight = fixed_fees.max_weight.value || maxWeight;
      maxDimension = fixed_fees.max_dimension.value || maxDimension;
      fixedShippingFee = fixed_fees.fixed_shipping_fee.value || fixedShippingFee;
    }
    
    return (
      <div>
        {/* 
          Start of Floodlight Tag: Please do not remove
          Activity name of this tag: Shipping-estimate
          URL of the webpage where the tag is expected to be placed: https://www.shippingcart.com/shipping-estimate
          This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
          Creation Date: 02/04/2020
         */}
        <noscript>
          <iframe title={uuid()} src="https://9848754.fls.doubleclick.net/activityi;src=9848754;type=shipp0;cat=shipp0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" frameBorder="0" style={{ display: 'none' }}></iframe>
        </noscript>
        {/*  End of Floodlight Tag: Please do not remove   */}
        <Helmet>
          <meta name="description" content={metadata} data-react-helmet="true" />
        </Helmet>
        {this.props.estimate.fetching && 
          <div style={{top: 0, right: 0, left: 0, bottom:0, position:'fixed', alignItems: 'center', background: 'rgba(0,0,0,0.6)',zIndex: '999999', justifyContent: 'center', display: 'flex'}}>
            <div style={{color: '#FFF', }}>
              <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        }
        <div className="page-estimateshipping">
          <div id="shippingcart_app" className="header-original">
            <div className="body-wrapper">

              <div>
                <div className="container estimate-shipping page-container">
                  <h1 className="page-title">Get Shipping Estimate</h1>

                  <div className="row">
                    <div className="col-md-7 estimate">
                      <div className="col-md-5 estimate-form" style={{width: '53%'}}>
                        <div className="instructions">
                          <p>
                            Get your shipment cost estimate with our cost estimator. The cost estimator is a tool that provides an estimate of your shipping fee and is based on the information that you provide. It does not reflect the actual shipment cost, which will depend on actual box measurements, shipping method, and currency rate, among others.
                                                </p>
                        </div>

                        <div className="cart-header">
                          <div className="shipment-destination">
                            <span>FROM: </span>
                            <div className="select-gradient disInline">
                              <select value={this.state.origin} onChange={(e) => this.onChangeLocation(e, "origin")}>
                                {this.props.warehouse.warehouse_fetched ? filterWarehouse(this.props.warehouse.warehouse.data, this.props.login.login.party).map(value =>
                                  <option key={value.id} value={value.id}>{maskLocationName(value.country_code)}</option>
                                ) : null}
                              </select>
                            </div>
                            <span>TO: </span>
                            <div className="select-gradient disInline">
                              <select value={this.state.destination} onChange={(e) => this.onChangeLocation(e, "destination")}>
                                <option value="PH">Philippines</option>
                                {/* {
                                  (this.state.origin !== '4' && this.state.origin !== '5') && <option value="MY">Malaysia</option>
                                } */}
                              </select>
                            </div>
                          </div>
                        </div>

                        <form onSubmit={this.onSubmit}>
                          <div className="notify">
                            {this.state.weight_status && this.state.width_status && this.state.length_status && this.state.height_status && this.state.insured_status ? null :
                              !this.state.number || !this.state.insured || !this.state.length || !this.state.width || !this.state.height ? <div className="sc-alert sc-alert-danger"><i className="sc"></i> Fill in all the required fields. </div> :
                                this.state.number <= 0 || this.state.insured < 1 || this.state.length <= 0 || this.state.width <= 0 || this.state.height <= 0 || this.state.insured > this.state.insurance_max ? <div className="sc-alert sc-alert-danger"><i className="sc"></i> Please check allowed minimum value </div> : null}
                          </div>

                          <div className="weight form-group">
                            <label className="control-label">How much does it weigh?</label>

                            {this.state.weight_status ? null :
                              !this.state.number ? <span className="inline-error-message"> {'\u00A0'} Enter weight </span> :
                                this.state.number <= 0 ? <span className="inline-error-message"> {'\u00A0'} Enter value greater than 0 </span> : null}

                            <div className="input-with-inline-text">
                              <input type="text" maxLength={this.state.max_weight} onInput={this.weightValidator} onChange={() => this.checkOffsizeItemsHandling(offSizeData)} className={this.state.weight_status ? "form-control" : "form-control error-input"} ref="weight" />
                              <span className="inline-text">pounds</span>
                            </div>
                          </div>

                          <div className="dimensions form-group">
                            <label className="control-label">
                              What are the dimensions?
                                                    </label>

                            {this.state.length_status && this.state.width_status && this.state.height_status ? null :
                              !this.state.length && !this.state.width && !this.state.height ? <span className="inline-error-message"> {'\u00A0'} Enter length, width and height </span> :
                                !this.state.length || !this.state.width || !this.state.height ? <span className="inline-error-message"> {'\u00A0'} Enter valid input </span> :
                                  this.state.length <= 0 || this.state.width <= 0 || this.state.height <= 0 ? <span className="inline-error-message"> {'\u00A0'} Enter value greater than 0 </span> : null}

                            <div className="input-with-inline-text">
                              <input type="text" maxLength={this.state.max_length} onInput={this.lengthValidator} onChange={() => this.checkOffsizeItemsHandling(offSizeData)} className={this.state.length_status ? "form-control" : "form-control error-input"} placeholder="length" ref="length" />
                              <input type="text" maxLength={this.state.max_width} onInput={this.widthValidator} onChange={() => this.checkOffsizeItemsHandling(offSizeData)} className={this.state.width_status ? "form-control" : "form-control error-input"} placeholder="width" ref="width" />
                              <input type="text" maxLength={this.state.max_height} onInput={this.heightValidator} onChange={() => this.checkOffsizeItemsHandling(offSizeData)} className={this.state.height_status ? "form-control" : "form-control error-input"} placeholder="height" ref="height" />
                              <span className="inline-text">inches</span>
                            </div>
                          </div>

                          <div className="insured-declared-value form-group">
                            <label className="control-label">
                              How much is the Insured Value?
                                                    </label>

                            <span className="error-message"> {this.state.insured > this.state.insurance_max ? this.state.insured_value_text : null} </span>
                            {this.state.insured_status ? null :
                              !this.state.insured ? <span className="error-message"> Enter Insured Value </span> :
                                this.state.insured <= 0 ? <span className="inline-error-message"> {'\u00A0'} Enter value greater than 0 </span> : null}

                            <div className="input-with-inline-text">
                              <span className="inline-text prefix">&#36;</span>
                              <input type="text" maxLength={this.state.max_insured} onInput={this.InsuredValueValidator} className={this.state.insured_status ? "form-control" : "form-control error-input"} ref="insured_value" />
                            </div>
                          </div>

                          <div className="special-handling form-group">
                            <label className="control-label">
                              Does your shipment have items that require special handling?
                                                    </label>

                            <select className="form-control" ref="special_handling" defaultValue={this.state.selectDefaultValue} disabled={this.state.offsize ? "disabled" : ""}  >
                              <option value={this.state.offsize ? this.state.selectDefaultValue : ""} selected="selected">{this.state.selectDefaultLabel}</option>
                              {this.state.offsize ? "" : "<option value='' selected='selected'>None</option>"}
                              <option value="automotive parts">Collectibles</option>
                              {offSizeData && this.state.offsize && <option value="off-size items">Off-size item exceeding {JSON.parse(offSizeData[0].settings).dimension.value} inches (any side) and/or {JSON.parse(offSizeData[0].settings).weight.value} lbs</option>}
                              <option value="telecom_equipment">Electronic products powered by Li-ion batteries</option>
                              <option value="fragile_breakable">Breakable / Fragile Items</option>
                            </select>

                          </div>

                          <div className="form-buttons">
                            <button type="submit" className="btn btn-orange gradient">
                              Get Shipping Estimate
                                                    </button>

                            <a className="reset-form" onClick={this.reset}>Reset</a>
                          </div>
                        </form>
                      </div>

                      <div className="col-md-7 estimate-results" style={{width: '48%'}}>
                        <div className="results">
                        {this.state.calculated ? this.state.offsize ? 
                          <div className="sc-warning" style={{ padding: '10px 24px',height: 'auto', background: '#FEF6E7', borderRadius: '5px', border: 'none', width: 'auto', margin: '10px' }}>
                            <div>Off-size items must be shipped individually. Additional charges may be billed on top of your shipping fee depending on the item.</div>
                            <a style={{ color: '#0375D9', fontWeight: 600, cursor: 'pointer', fontSize: '14px'}} href='https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-' target="_blank" rel="noopener noreferrer" >
                              <i
                                className="fa fa-exclamation-circle"
                                style={{color: '#0375D9', fontSize: 13, marginRight: '5px' }}
                              />
                              Learn more.
                            </a>
                          </div>
                           : <div style={{margin: 10}}><OutBoundBanner outBoundBannerData={outBoundBannerData}/></div> : null}
                          {
                            this.state.calculated ? null :
                              <div className="estimate-instruction">
                                <i className="sc sc-light-box" />
                                <p>Fill in the appropriate fields as accurately as possible to get your shipping fee estimation.</p>
                              </div>
                          }
                          {this.state.calculated ?
                            <div><ShippingEstimateBreakdown data={this.props.estimate.estimate.data} offSize={this.state.offsize} destination={this.state.destination} minChargableWeight={minChargableWeight}/></div>
                            : null}

                        </div>
                      </div>
                    </div>
                    <div className="col-md-5 rates">
                      <h3 className="section-title">Rates</h3>

                      <p>ShippingCart can ship your goods home via Air or Sea Cargo.</p>
                      <p>Shipment cost is computed using pounds (lbs) and US Dollars and is inclusive of all taxes.</p>

                      <table className="table rate-list">
                        <thead>
                          <th>Shipment Method</th>
                          <th>Rate</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Air Cargo</td>
                            <td>USD{per_pound ? JSON.parse(per_pound[0].settings).lbs_value_air.value : null}/pound</td>
                          </tr>
                          <tr>
                            <td>Air Cargo (<Link to="/special-handling">Special Handling</Link>)</td>
                            <td>USD{per_pound ? JSON.parse(per_pound[0].settings).lbs_value_special_handling_air ? JSON.parse(per_pound[0].settings).lbs_value_special_handling_air.value : JSON.parse(per_pound[0].settings).lbs_value_dangerous_air.value : null}/pound</td>
                          </tr>
                          </tbody>
                          { this.state.destination !== 'MY' &&
                          <tbody style={{ borderTop: 'none' }}>
                            <tr>
                              <td>Sea Cargo</td>
                              <td>USD{per_pound ? JSON.parse(per_pound[0].settings).lbs_value_sea.value : null}/cubic inch <br /> (unliweight)</td>
                            </tr>
                            <tr>
                              <td>Sea Cargo (<Link to="/special-handling">Special Handling</Link>)</td>
                              <td>USD{per_pound ? JSON.parse(per_pound[0].settings).lbs_value_special_handling_sea.value : null}/cubic inch <br /> (unliweight)</td>
                            </tr>
                            <tr>
                              <td>Sea Cargo (<a href="https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-" target="_blank" rel="noopener noreferrer">Off-size</a>)</td>
                              <td>USD{per_pound ? JSON.parse(per_pound[0].settings).offsize_rate_sea.value : null}/cubic inch <br /> (unliweight)</td>
                            </tr>
                          </tbody>
                          }
                        
                      </table>

                      <p className="bold" style={{ marginBottom: '0px' }}>How do I calculate the Shipment Cost?</p>
                      <p>Shipment cost is calculated as follows:
                      <br />Cargo Fee + Fixed Handling Fee + Storage Fee (if any) + SC Protect Fee (if any)</p>
                      <p>We highly recommend that you encode the correct insured value of your items so that you will be fairly reimbursed for any unfortunate incidents that may occur. <Link to="/sc-protect">SC Protect</Link> covers up to $20,000 per shipment, with a $10,000 limit per item.</p>
                      
                      <p className="bold" style={{ marginBottom: '0px' }}>How do I compute Cargo Fee?</p>
                      <p>Cargo Fee is charged as either a fixed fee or computed based on the total chargeable weight.</p>
                      <p>A single item under {maxWeight}lbs with dimension not greater than {maxDimension}inches (any side) is charged a fixed air cargo fee of ${fixedShippingFee} if shipped via Air Cargo.</p>
                      <p>Otherwise, cargo fee is computed based on <strong>Chargeable Weight x Rate</strong>. A Fixed Handling Fee of ${airFixedFee} is added when the cargo fee is computed based on chargeable weight.</p>

                      <p className="bold" style={{ marginBottom: '0px' }}>What is chargeable weight?</p>
                      <p>The chargeable weight for your package is its actual weight or volumetric weight, whichever is higher. ShippingCart rounds up to two decimal places of the chargeable weight. Minimum chargeable weight is 1lb for Air Cargo and volumetric weight of a 12x12x12 box for Sea Cargo. To determine the actual and volumetric weight of your package, a dimensioning machine is used to weigh your item/s. This is done while it's inside its original packaging. Note that if your item/s arrives in your courier's or distributor's box (e.g. Fedex, Amazon), we remove the courier's box before your item(s) is measured and weighed. We measure and weigh your item/s in its original/manufacturer's packaging to help you save on shipping fees.</p>
                      <p>The formula for Volumetric Weight is: Length x Width x Height / 166 (dimensional weight factor). 
                      <br /><em style={{ fontSize: '12px' }}>*Sea Cargo Shipments are only measured based on the volumetric weight or dimensional weight.</em></p>
                      <p>Please note that we follow the dimensional weight factor of the International Air Weight Transport Association (IATA).</p>

                      <p className="bold" style={{ marginBottom: '0px' }}>Special Handling and Off-size Items</p>
                      <p>We offer shipping for items that require special handling (i.e. dangerous goods). For a complete list of these items, visit our <Link to="/special-handling">Special Handling Service Guide</Link>.</p>
                      <p>It's important to remember that when an item requiring special handling is consolidated with regular items for shipment, the rate for Air Cargo for Items with Special Handling applies. Consolidation is free.</p>
                      <p>An item will be tagged as “off-size” in your cart if it exceeds the allowable maximum dimension and/or weight that can be shipped via air cargo depending on which origin the item will be coming from. Values may differ for each origin as this is based on our Forwarding partner’s capacity. <Link to="https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-">Off-size items can only be shipped via sea cargo to the PH</Link>.</p>
                    </div>
                  </div>
                </div>
                <template id="alerts_component_template">
                  <div className="sc-alert">
                    <i className="sc"></i> <span> </span>
                  </div>
                </template>
              </div>

            </div>

          </div>
        </div>

      </div>
    )
  },


});

const mapDispachToProps = { getWarehouse }

const mapStateToProps = state => ({ warehouse: state.dashboard })

export default connect(mapStateToProps, mapDispachToProps)(ShippingEstimate);



/** WEBPACK FOOTER **
 ** ./src/components/ShippingEstimate.js
 **/